import { Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UigShopViewService } from 'src/app/services/uig-shop-view.service';

@Component({
    selector: 'app-uig-product-details-container',
    templateUrl: './uig-product-details-container.component.html',
    styleUrls: ['./uig-product-details-container.component.scss'],
    standalone: false
})
export class UigProductDetailsContainerComponent implements OnInit {
  public product$: Observable<Product>;
  hasShopViewUserRole: boolean = true;

  constructor(private currentProductService: CurrentProductService,
              private uigShopViewService:UigShopViewService) {
    this.uigShopViewService.isShopViewMode().subscribe((hasRole) =>{
      this.hasShopViewUserRole = hasRole;
    })
  }

  public ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }

  getTranslateOptions(product: Product)  {
    return {
      deliveryCostBulkyDirect: product.deliveryCostBulkyDirect?.formattedValue
    }
  }
}
